import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import trans from 'counterpart'
import moment from 'moment'
import Link from '../../../../components/typography/Link'
import Modal from '../../../../components/modals/Modal'
import ModalBody from '../../../../components/modals/ModalBody'
import ModalFooter from '../../../../components/modals/ModalFooter'
import { INTERNAL_DATE } from '../../../../constants/dates'

const BookButton = ({ arrivalDate, className, disabled, history, to, toFallback, panic }) => {
  const [modal, setModal] = useState(false)

  const toggleModal = (e) => {
    e.preventDefault()
    const now = moment()

    if (now.hours() >= 12 && now.format(INTERNAL_DATE) === arrivalDate) {
      return setModal(true)
    }

    return history.push(to)
  }

  return (
    <>
      {!panic && (
        <>
          {disabled && (
            <button type='button' className={`btn btn-booking ${className}`} disabled={disabled}>
              <span>{trans('newyse.accommodation.book')}</span>
              {' '}
              <i className='material-icons'>arrow_forward</i>
            </button>
          )}
          {!disabled && (
            <>
              <a href={to} className={`btn btn-booking ${className}`} onClick={toggleModal}>
                <span>{trans('newyse.accommodation.book')}</span>
                {' '}
                <i className='material-icons'>arrow_forward</i>
              </a>
              <Modal isOpen={modal} toggle={() => { setModal(false) }}>
                <ModalBody>
                  {trans('newyse.accommodation.booking_offline_warning')}
                </ModalBody>
                <ModalFooter>
                  <button type='button' className='btn btn-green btn-block' onClick={() => { setModal(false) }}>
                    {trans('button.close')}
                  </button>
                </ModalFooter>
              </Modal>
            </>
          )}
        </>
      )}
      {panic && (
        <Link
          to={toFallback}
          className={`btn btn-green ${className}`}
        >
          {trans('newyse.accommodation.book')}
        </Link>
      )}
    </>
  )
}

BookButton.propTypes = {
  arrivalDate: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  history: PropTypes.func.isRequired,
  panic: PropTypes.bool.isRequired,
  to: PropTypes.string.isRequired,
  toFallback: PropTypes.string.isRequired
}

export default withRouter(BookButton)
